import {
	ListGroup,
	TextFieldEntry,
	isTextFieldEntryEdited
	} from '@bpmn-io/properties-panel';

import {useService} from 'bpmn-js-properties-panel';
import {html} from 'htm/preact';


export default function(element)
	{
	return [
		{
			id:'form',
			element,
			component:FormBox,
			isEdited:isTextFieldEntryEdited
		}
	];
	}


export function ConditionalVariable(element)
	{
	return [
		{
			id:'form',
			element,
			component:ConditionBox,
			isEdited:isTextFieldEntryEdited
		}
	];
	}


export function PrefixVariable(element)
	{
	return [
		{
			id:'prefix',
			element,
			component:PrefixBox,
			isEdited:isTextFieldEntryEdited
		}
	];
	}


function PrefixBox(props)
	{
	const {element,id}=props;

	const modeling=useService('modeling');
	const translate=useService('translate');
	const debounce=useService('debounceInput');

	const getValue=()=>
		{
		return element.businessObject?.prefixProcess||"";
		};

	const setValue=(value)=>
		{
		return modeling.updateProperties(element,{
			prefixProcess:value
			});
		};

	return html`<${TextFieldEntry}
		id=${id}
		element=${element}
		description=${translate('Enter the prefix for this process')}
		label=${translate('Prefix')}
		getValue=${getValue}
		setValue=${setValue}
		debounce=${debounce}
	/>`;
	}


function ConditionBox(props)
	{
	const {element,id}=props;

	const modeling=useService('modeling');
	const translate=useService('translate');
	const debounce=useService('debounceInput');

	const getValue=()=>
		{
		return element.businessObject?.condition||"";
		};

	const setValue=(value)=>
		{
		return modeling.updateProperties(element,{
			condition:value,
			name:value
			});
		};

	return html`<${TextFieldEntry}
		id=${id}
		element=${element}
		description=${translate('Enter a variable or expression')}
		label=${translate('Condition')}
		getValue=${getValue}
		setValue=${setValue}
		debounce=${debounce}
	/>`;
	}


function FormBox(props)
	{
	const {element,id}=props;

	const modeling=useService('modeling');
	const translate=useService('translate');
	const debounce=useService('debounceInput');

	const getValue=()=>
		{
		return element.businessObject?.spell||"";
		};

	const setValue=(value)=>
		{
		return modeling.updateProperties(element,{
			spell:value
			});
		};

	return html`<${TextFieldEntry}
		id=${id}
		element=${element}
		description=${translate('Select a form used to complete this process')}
		label=${translate('Process Form')}
		getValue=${getValue}
		setValue=${setValue}
		debounce=${debounce}
	/>`;
	}


/*
 * Process Variables
 */

export function ProcessVariables(element,injector)
	{
	const bpmnFactory=injector.get('bpmnFactory');
	const commandStack=injector.get('commandStack');

	var container=element.businessObject.get('processVariables');
	var variables=container?.get('values')||[];

	var items=variables.map((variable,index)=>
		{
		var id=`${element.id}-processVariable-${index}`;

		return {
			id,
			label:variable.get('name')||`Variable ${index+1}`,
			entries:ProcessVariableEntries(element,index,id),
			autoFocusEntry:`${id}-name`,
			remove:removeVariable({
				element,
				variable,
				container,
				commandStack
				})
			};
		});

	return {
		id:'processVariables',
		label:'Process Variables',
		component:ListGroup,
		items,
		add:addVariable({
			element,
			bpmnFactory,
			commandStack
			})
		};
	}


function addVariable({element,bpmnFactory,commandStack})
	{
	return function(event)
		{
		event?.stopPropagation();

		const commands=[];
		const businessObject=element.businessObject;

		var container=businessObject.get('processVariables');

		if (!container)
			{
			container=bpmnFactory.create('magic:ProcessVariables',{
				values:[]
				});

			commands.push({
				cmd:'element.updateModdleProperties',
				context:{
					element,
					moddleElement:businessObject,
					properties:{
						processVariables:container
						}
					}
				});
			}

		var variable=bpmnFactory.create('magic:ProcessVariable',{
			name:'',
			value:''
			});

		commands.push({
			cmd:'element.updateModdleProperties',
			context:{
				element,
				moddleElement:container,
				properties:{
					values:[...(container.get('values')||[]),variable]
					}
				}
			});

		return commandStack.execute(
			'properties-panel.multi-command-executor',
			commands
			);
		};
	}


function removeVariable({element,variable,container,commandStack})
	{
	return function(event)
		{
		event?.stopPropagation();

		var values=container?.get('values')||[];

		return commandStack.execute('element.updateModdleProperties',{
			element,
			moddleElement:container,
			properties:{
				values:values.filter((x)=>x!==variable)
				}
			});
		};
	}


function ProcessVariableEntries(element,index,id)
	{
	return [
		{
			id:`${id}-name`,
			element,
			component:ProcessVariableNameField,
			isEdited:isTextFieldEntryEdited
		},
		{
			id:`${id}-value`,
			element,
			component:ProcessVariableValueField,
			isEdited:isTextFieldEntryEdited
		}
	];
	}


function ProcessVariableNameField(props)
	{
	return ProcessVariableField({
		...props,
		field:'name'
		});
	}


function ProcessVariableValueField(props)
	{
	return ProcessVariableField({
		...props,
		field:'value'
		});
	}


function ProcessVariableField(props)
	{
	const {element,id,field}=props;

	const commandStack=useService('commandStack');
	const translate=useService('translate');
	const debounce=useService('debounceInput');

	const getValue=()=>
		{
		var variable=getProcessVariable(element,id);

		return variable?.get(field)||"";
		};

	const setValue=(value)=>
		{
		var variable=getProcessVariable(element,id);

		if (!variable)
			return;

		return commandStack.execute('element.updateModdleProperties',{
			element,
			moddleElement:variable,
			properties:{
				[field]:value
				}
			});
		};

	return html`<${TextFieldEntry}
		id=${id}
		element=${element}
		label=${translate(field=="name"?"Variable":"Value")}
		getValue=${getValue}
		setValue=${setValue}
		debounce=${debounce}
	/>`;
	}


function getProcessVariable(element,id)
	{
	var match=id.match(/processVariable-(\d+)-(name|value)$/);

	if (!match)
		return null;

	var index=parseInt(match[1]);

	var container=element.businessObject.get('processVariables');
	var variables=container?.get('values')||[];

	return variables[index]||null;
	}
